import { hotlineText } from '@/feature/hotline/constant/text';
import { t } from '@/utils/constants/text/text';
import { z } from '@/utils/libs/zod/base';
const messages = t.validation;
const { label } = hotlineText;
/**
 * 匿名コンサルホットライン ホットライン申し込み日程新規作成 schema
 */
export const hotlineScheduleFormSchema = z.object({
    /**
     * 面談時間
     */
    interviewTime: z.number({
        required_error: messages.requiredSelect(label.interviewTime()),
    }),
    /**
     * 相談開始日時
     */
    interviewedFromAt: z.date({
        invalid_type_error: messages.format(label.interviewedFromAt()),
        required_error: messages.requiredSelect(label.interviewedFromAt()),
    }),
});
